import { Types } from './types'
/**
 * Retorna si el contenido esta disponible
 * @param status
 */
export const handleEnable = (status: Types.Status) => {
  return status !== null ? status?.enabled : true
}
